import { render, staticRenderFns } from "./My.vue?vue&type=template&id=739f4f2d&scoped=true"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"
import style0 from "./My.vue?vue&type=style&index=0&id=739f4f2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f4f2d",
  null
  
)

export default component.exports